import { JobStatus } from '../../../../../redux/jobs/jobs.types';
import { MaybeUndef } from '../../../../../types/system';
import { OperationStatus } from '../../operation-groups.types';

const statusesMap = {
  [JobStatus.ERROR]: OperationStatus.Failed,
  [JobStatus.SUCCESS]: OperationStatus.Succeeded,
  [JobStatus.WORKING]: OperationStatus.InProgress,
  [JobStatus.PENDING]: OperationStatus.InProgress,
};

export function jobStatusToGenericOperationStatus(
  uploadStatus: MaybeUndef<JobStatus>,
): OperationStatus {
  return uploadStatus ? statusesMap[uploadStatus] : OperationStatus.Pending;
}
